<template>
  <div class='h100vh-60'>
    <TsCommonMenu ref='tsMenuButton' :searchBtn='true' :exportBtn='true' @methodEnum='methodEnum' ></TsCommonMenu>
    <div class="olap-contentBox">
      <div class='olap-viewBox' ref="imageWrapper">
        <div class='h-col-viewBox-colspan-1'>
          <div class='olap-splitView'>
            <EchartsPie ref='view1' :element='view1ChartsSetting.element'></EchartsPie>
          </div>
        </div>
        <div class='h-col-viewBox-colspan-1'>
          <div class='olap-splitView'>
            <EchartsPie ref='view2' :element='view2ChartsSetting.element'></EchartsPie>
          </div>
        </div>
        <div class='h-col-viewBox-colspan-2'>
          <!--<div class='olap-scale_link' state="normal"></div>-->
          <div class='olap-splitView'>
            <EchartsBar ref='view3' :element='view3ChartsSetting.element'></EchartsBar>
          </div>
        </div>
      </div>
    </div>
    <CustomDialog ref='searchDialog' :element='searchDialogSetting.element' :styles='searchDialogSetting.styles' :messages='searchDialogSetting.messages'>
      <template v-slot:dialog-content>
        <QueryCondition ref="query"></QueryCondition>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import echarts from 'echarts';
  import html2canvas from "html2canvas"
  import Vue from 'vue';
  import EchartsPie from '../../echarts/EchartsPie';
  import EchartsBar from '../../echarts/EchartsBar';
  import CustomDialog from '../../../common/CustomDialog';
  import TsCommonMenu from '../TsCommonMenu';
  import QueryCondition from '../QueryConditionDialog';
  import { EventBus } from '../../../../plugins/eventBus';
  import Global from '../../Global';

  Vue.prototype.$echarts = echarts;
  export default {
    name: 'CallTimeChartsList',
    components: {
      EchartsPie,
      EchartsBar,
      CustomDialog,
      TsCommonMenu,
      QueryCondition
    },
    data() {
      return {
        olapUrl: Global.olapUrl,
        queryConditions: {},
        view1ChartsSetting: {
          element: {
            title: '系统呼叫类型次数统计',
            unit: '次',//单位
            legendData: ['语音单呼次数', '语音组呼次数', '视频单呼次数', '视频组呼次数'],
            xAxisData: []//柱形图使用
          }
        },
        view2ChartsSetting: {
          element: {
            title: '系统呼叫范围次数统计',
            unit: '次',//单位
            legendData: ['单系统呼叫次数', '跨系统呼叫次数'],
            xAxisData: []//柱形图使用
          }
        },
        view3ChartsSetting: {
          element: {
            title: '系统呼叫业务类型次数统计',
            unit: '次',//单位
            legendData: [],
            xAxisData: ['全双工语音呼叫', '半双工语音呼叫', '语音组呼', '环境监听', '视频单呼', '同源视频组呼', '不同源视频组呼', '视频推送',
              '视频上拉', '视频回传', '音视频环境监视', '纯视频环境监视', '语音组播', '音视频组播', '纯视频组播', '视频转发给组',
              '视频转发给用户', '视频推送给用户', '视频推送给组']//柱形图使用
          }
        },
        searchDialogSetting: {
          styles: {
            width: '860px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'search',
            title: this.$t('Track.createTask'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.cancel') } },
              { click: this.queryConfirm, buttonModel: { content: this.$t('Track.confirm'), isPrimary: true } }
            ]
          },
          messages: {
            title: this.$t('TS.gs_search')
          }
        }
      };
    },
    mounted() {
      this.queryConfirm();
    },
    methods: {
      methodEnum(opcode) {
        switch (opcode) {
          case 'search':
            this.$refs.searchDialog.show();
            break;
          case 'import':
            this.exportImg();
            break;
          default:
        }
      },
      dialogHide() {
        this.$refs.searchDialog.clear();
        this.$refs.searchDialog.close();
      },
      queryConfirm(params) {
        const $this = this;
        const seriesData1 = [100,50,150,250];
        $this.$refs.view1.setDatas(seriesData1);
        const seriesData2 = [1000,650];
        $this.$refs.view2.setDatas(seriesData2);
        const seriesData3 = [50, 100, 80, 70, 200, 160, 40, 20, 90, 80, 70, 130, 140, 150, 80, 70, 80, 50, 100];
        $this.$refs.view3.setDatas(seriesData3);
        // $this.queryConditions = $this.$refs.query.getQueryCondition();
        // console.log($this.searchConditions);
        // if ($this.searchConditions) {
        //   const url = `${This.olapUrl}/lte/ems/olap/voice/getAllCountAndFailCount.html?startDate=${this.searchConditions.startdate}&endDate=${this.searchConditions.enddate}&interval=${this.searchConditions.timeInterval}&neId=${this.searchConditions.neId}`;
        //   // const url = `/olap/lte/ems/olap/voice/getAllCountAndFailCount.html?startDate=${this.searchConditions.startdate}&endDate=${this.searchConditions.enddate}&interval=${this.searchConditions.timeInterval}&neId=${this.searchConditions.neId}`;
        //   $this.$loading.showLoadding($this.$t('MML.loadingTip'));
        //   $this.$axios.get(url).then((response) => {
        //     if (response && response.status === 200) {
        //
        //     }
        //     $this.dialogHide();
        //     $this.$loading.hideLoadding();
        //   }).catch(err => {
        //     $this.$loading.hideLoadding();
        //   });
        // }
      },
      exportImg() {
        html2canvas(this.$refs.imageWrapper,{
          backgroundColor: null
        }).then(canvas => {
          const dataURL = canvas.toDataURL("image/png");
          const alink = document.createElement("a");
          alink.href = dataURL;
          alink.download = "系统呼叫时长统计"; //导出的图片名
          alink.click();
        });
      },
      longToString(longTypeDate) {
        let datetimeType = '';
        const date = new Date();
        date.setTime(longTypeDate);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const strDate = date.getDate().toString().padStart(2, '0');
        datetimeType = `${date.getFullYear()}-${month}-${strDate} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
        return datetimeType;
      }
    }
  };

</script>

<style scoped>

</style>
